import { parseDateCreated } from "../utils";

export class Invoice {
  invoiceNumber: string;
  dueDate: string;
  totalAmount: number;
  openAmount: number;
  bookingDate: string | string[]; // bookingDate can sometimes be a date or an array of dates
  referenceNumber: string;
  invoiceStatus: InvoiceStatus;
  reminderDate: string;
  firstDunningDate: string;
  secondDunningDate: string;
  suspensionDate: string;
  sumPremiumAccount: number;
  paymentStatus?: InvoiceStatus;
  bexio_document_nr?: string;
  bexio_network_link?: string;
  bexio_invoice_id?: string;
  bexio_pdf_available?: boolean;

  constructor(
    dateCreated: string,
    invoiceNumber: string,
    dueDate: string,
    totalAmount: number,
    openAmount: number,
    bookingDate: string | string[],
    referenceNumber: string,
    invoiceStatus: InvoiceStatus,
    reminderDate: string,
    firstDunningDate: string,
    secondDunningDate: string,
    suspensionDate: string,
    SumPremiumAccount: number
  ) {
    this._dateCreated = parseDateCreated(dateCreated);
    this.invoiceNumber = invoiceNumber;
    this.dueDate = dueDate;
    this.totalAmount = totalAmount;
    this.openAmount = openAmount;
    this.bookingDate = bookingDate;
    this.referenceNumber = referenceNumber;
    this.invoiceStatus = invoiceStatus;
    this.reminderDate = reminderDate;
    this.firstDunningDate = firstDunningDate;
    this.secondDunningDate = secondDunningDate;
    this.suspensionDate = suspensionDate;
    this.sumPremiumAccount = SumPremiumAccount;
  }

  private _dateCreated?: Date;

  get dateCreated(): string | Date {
    return this._dateCreated || new Date();
  }

  set dateCreated(date: Date | string) {
    if (typeof date === 'string') {
      this._dateCreated = parseDateCreated(date);
    } else {
      this._dateCreated = date;
    }
  }
}

/** Payload of `/get-invoice-pdf/{invoiceId}`: the PDF is no longer part of the contract list. */
export interface InvoicePdfDto {
  /** File name to save the document as. */
  name: string;
  /** Size of the decoded document in bytes. */
  size: number;
  /** The PDF, base64 encoded. */
  content: string;
}

export enum InvoiceStatus {
  OUTDATED = 'OUTDATED',
  AGGREGATED = 'AGGREGATED',
  PAID = 'PAID',
  OUTSTANDING = 'OUTSTANDING',
  FUTURE = 'FUTURE',
}

export type YearListItem<T> = {
  year: string;
  expanded: boolean;
  items: T[];
}
